import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { STORE_PATH, storeCustomizePath } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

export interface GuestQuoteDraftMissingProps {
  /** 주소의 상품 id(정규화) — 올바르면 그 상품 에디터로 돌아가는 링크를 둔다. 주소가 잘못됐으면 null. */
  readonly productId: string | null;
}

/**
 * 비회원 요청 화면에서 디자인(에디터 임시 작업)을 찾지 못했을 때의 안내(설계 G12·G13) — 주소를 직접 열었거나, 다른 브라우저·기기이거나,
 * 이미 접수해 임시 작업이 지워진 경우다. 머리의 얇은 아랫선과 겹치지 않게 아랫선만 둔다(회원 요청 화면 안내와 같은 결).
 */
export const GuestQuoteDraftMissing = ({
  productId,
}: GuestQuoteDraftMissingProps): ReactElement => (
  <div className="flex flex-col items-center gap-4 border-b border-foreground/10 py-16 text-center">
    <p className="text-lg font-bold tracking-[-0.02em]">견적을 요청할 디자인을 찾지 못했어요</p>
    <p className="max-w-xl text-sm leading-relaxed text-muted-foreground">
      에디터에서 디자인을 만든 뒤 [견적 요청하기]를 눌러 주세요. 로그인하지 않고 만든 디자인은 그
      브라우저에만 임시로 저장돼요.
    </p>
    <div className="flex flex-wrap justify-center gap-3">
      {productId !== null ? (
        <Link
          to={storeCustomizePath(productId)}
          className={cn(buttonVariants({ size: 'lg' }), 'h-11 px-6')}
        >
          디자인하러 가기
        </Link>
      ) : null}
      <Link
        to={STORE_PATH}
        className={cn(
          buttonVariants({ variant: 'outline', size: 'lg' }),
          'h-11 border-foreground/20 px-6',
        )}
      >
        스토어로 가기
      </Link>
    </div>
  </div>
);
